import React from 'react';
import { parseISO } from 'date-fns';
import { QRCode } from 'react-qrcode-logo';
import { formatInTimeZone } from 'date-fns-tz';

import { BtnRevealQrCode, Container } from './styles';

import logo from '~/assets/logos/logo.png';

interface ITicket {
  code: string;
  event: string;
  event_date: string;
  name: string;
  document: string;
  modality: string;
  category: string;
  address: string;
  email: string;
  phone: string;
  event_id: string;
  kit?: {
    color?: string;
    size?: string;
  };
}

interface ITicketProps {
  ticket: ITicket;
}

const Ticket: React.FC<ITicketProps> = ({ ticket }) => {
  // subir
  return (
    <Container>
      <div
        id={`ticket-${ticket.code}`}
        className="bg-ticket position-relative mt-3 py-5"
      >
        <div className="line-upper-left" />
        <div className="line-upper-right" />
        <div className="line-lower-left" />
        <div className="bg-qr-orange" />
        <BtnRevealQrCode
          type="button"
          className="border-0 bg-transparent d-block mx-auto"
        >
          <div className="text-center p-3 index">
            <div className="bd-qrcode mt-5">
              <QRCode
                value={`Identificador: #${ticket.code};`}
                removeQrCodeBehindLogo
                logoImage={logo}
                logoPadding={5}
                size={250}
                ecLevel="L"
              />
            </div>
            <p className="mx-auto px-2 py-1 mb-0 mt-2 ident">
              Identificador <br />#{ticket.code}
            </p>
          </div>
        </BtnRevealQrCode>

        <div className="d-flex justify-content-between align-items-start px-3 mt-3 mb-2">
          <h2 className="h5 mb-0">
            {ticket.event}
            <br />
            <span className="data">
              <span>Data do evento:</span>{' '}
              {formatInTimeZone(
                parseISO(ticket.event_date),
                'Europe/London',
                'dd/MM/yyyy'
              )}
            </span>
          </h2>
        </div>
        <div className="px-3 pb-3">
          <p className="mb-2">
            <span className="me-2">Nome: </span>
            {ticket.name}
          </p>
          <p className="mb-2">
            <span className="me-2">Documento: </span>
            ****{ticket.document.slice(4, 11)}***
          </p>
          <p className="mb-2">
            <span className="me-2">Modalidade: </span>
            {ticket.modality}
          </p>
          <p className="mb-2">
            <span className="me-2">Categoria: </span>
            {ticket.category}
          </p>

          <p className="mb-0">
            <span className="me-2">Endereço: </span>
            {ticket.address?.replace('Nº 0', 'S/N')}
          </p>
        </div>
      </div>
    </Container>
  );
};

export default Ticket;
